/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 29.04.2016.
 */

import Ratings from './ratings';

export default Ratings;


// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Ratings/index.js